/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { TableUpdate } from '../../models/communication/app-state.model';
import { GameBase } from '../game-base';
import { GameFlowBase } from '../game-flow-base';

export class ClassicGameFlow extends GameFlowBase<GameBase> {
    override update(tableUpdate?: TableUpdate): void {
        if (!this.game.isUpdateDataValid(tableUpdate)) {
            return;
        }

        if ('cardPosition' in tableUpdate) {
            this.game.showCard(tableUpdate.cardPosition!, tableUpdate.card!);
            this.game.showHandValue(tableUpdate);
        }

        if ('nextCardPosition' in tableUpdate) {
            this.game.showFaceUpMessage(tableUpdate.nextCardPosition!);
        }

        if ('outcome' in tableUpdate) {
            this.game.handleOutcome(tableUpdate);
        }
    }
}
